<div *ngFor="let alert of alerts" class="{{cssClass(alert)}}">
    <span [innerHTML]="alert.message"></span>
    <a class="close" (click)="removeAlert(alert)" style="font-size: 1.2rem !important;">&times;</a>
</div>